// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__Df9xY","col":"CardReaderDesc_col__1PXGi","label":"CardReaderDesc_label__3FknQ"};